import React from 'react';

const ButtonGroup = (props) => {

  return (
    <div className="mb-4 mt-3">
      <div className="mb-2"><strong>{props.title}</strong></div>
      <div className="btn-group" role="group" aria-label={props.label}>
        {props.options && props.options.map((o, i) =>
          <button key={i} type="button" className={`btn btn-sm btn-outline-secondary ${props.selected === o && 'active'}`} onClick={() => props.onClick(o)}>{o.label}</button>
        )}
      </div>
    </div>
  );
}

export default ButtonGroup;